import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close_thin",
  "use": "close_thin-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 16\" id=\"close_thin\"><path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#FF4743\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m1.333.333 15.334 15.334m0-15.334L1.333 15.667\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol